import { useNavigate } from 'react-router-dom';
import AccountStatement from './AccountStatement.jsx';

export default function AccountStatementModal({ cliente, open, onClose }) {
  const navigate = useNavigate();
  if (!open || !cliente?.id) return null;
  return (
    <div onClick={(event) => event.stopPropagation()} className="fixed inset-0 z-[80] flex items-center justify-center bg-black/55 p-[3vh_4vw]" role="dialog" aria-modal="true" aria-label={`Estado de cuenta de ${cliente.razonSocial || 'cliente'}`}>
      <div className="h-[92vh] w-[94vw] max-w-[1800px] overflow-hidden rounded-2xl shadow-2xl">
        <AccountStatement
          clienteId={cliente.id}
          mode="modal"
          onClose={onClose}
          onOpenFull={() => {
            onClose?.();
            navigate(`/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta?clienteId=${cliente.id}`);
          }}
        />
      </div>
    </div>
  );
}
